import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { EnvironmentApi } from '@env0/environment-service/api';

type EnvironmentsWithOutputsScope = Omit<EnvironmentApi.GetEnvironmentsWithOutputs.Request.QueryParams, 'projectId'>;

export default (client: HttpClient) => ({
  getEnvironmentsWithOutputsForProject: async (projectId: string, scope?: EnvironmentsWithOutputsScope) =>
    client
      .get<EnvironmentApi.GetEnvironmentsWithOutputs.Response>(`environment-outputs/by-environment`, {
        params: { projectId, ...scope }
      })
      .then(returnData),

  getProjectsWithOutputs: async (projectId: string) =>
    client
      .get<EnvironmentApi.GetProjectsWithOutputs.Response>(`environment-outputs/projects`, {
        params: { projectId }
      })
      .then(returnData)
});
